import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CONSTANT_VALUES } from '../../../constants/constant-values';
import { AppService } from '../../../app.service';

import { MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, SetAllMemberCheck } from './../../../shared/message.event';
import { FeedService } from './../../feed.service';
import { CONSTANT_MESSAGES } from '../../../constants/constants-messages';
import * as moment from 'moment';
import { UISETTING } from './../../../shared/ui-setting';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    providers: [MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, FeedService, SetAllMemberCheck]
})
export class AlertComponent implements OnInit {
    public appCall: any;
    private _router;
    private shouldSlide: boolean = false;
    private divHeight = 30;
    private pagebutton = 30;
    private vendor;
    private message = '';
    private noFeedbackText = true;
    private clubName = '';
    private facilityList = [];
    private category = 'ALERT';
    private categoryList = CONSTANT_VALUES.CATEGORY_LIST_FOR_FEED;
    private feed;
    filesToUpload: any;
    private _feedService;
    private popUpMessage;
    private fileUrl;
    private createdAt = '';
    private uiSetting: UISETTING;
    private height: any;

    constructor(private router: Router, private appService: AppService,
        private messageEvent: MessageEvent, private signInEvent: SignInEvent,
        private loaderEvent: LoaderEvent, private facilityListEvent: FacilityListEvent,
        private openFrameEvent: OpenFrameEvent, private feedService: FeedService, private setAllMemberCheck: SetAllMemberCheck) {
        this.uiSetting = {
            'windowHeight': window.innerHeight,
            'topNav': 56,
            'midNav': 45,
            'footer': 35,
            'container': 40
        }
        this._router = router;
        appService;
        this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer + this.divHeight + this.pagebutton)) + 'px';
        this._feedService = feedService;
        this.feed = {
            title: '',
            content: '',
            vendorId: '',
            facilities: '',
            sendToAll: false,
            file: '',
            sendOn: ''
        };
    }

    ngOnInit() {
        this.emitOpenFrameEvent();
        window.scrollTo(0, 0);
        let vendor = localStorage.getItem('vendor');
        if (vendor) {
            this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
            if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
                if (this.vendor.subVendors.length > 0) {
                    let subVendor = this.vendor.subVendors[0];
                    this.clubName = subVendor.clubName;
                }
            } else {
                this.clubName = this.vendor.clubName;
            }
            this.createdAt = moment(new Date()).format('dddd, MMM DD, YYYY');
            this.getClubFacility();
        }
        this.registerTypeBroadcast();
        this.emitTypeBroadcast();
    }

    /**
     * while menu slide left to right as well as we shift header, footer and body too like menu by broadcaster
     */

    registerTypeBroadcast() {
        this.messageEvent.on()
            .subscribe(message => {
                this.shouldSlide = message;
            });
    }

    /**
     * function show menu at facility page by broadcaster
     */

    emitTypeBroadcast() {
        this.signInEvent.fire('block');
    }
    emitTypeLoaderBroadcast() {
        this.loaderEvent.fire(false);
    }
    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }

    getClubFacility() {
        this.appService.getFacilityList(this.vendor._id).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.facilityList = result.facilityData;
            } else {
            }
        });
    }

    selectCategory(para) {
        this.category = para
        let that = this;
        setTimeout(function () {
            if (that.category === 'BROADCAST') {
                that._router.navigate(['/broadcast']);
            }
        }, 100);
    }

    sendFeed(popupObj, backPopUpObj) {
        try {
            let form_data = new FormData();
            if (this.validateFeed(popupObj)) {
                this.loaderEvent.fire(false);
                form_data.append('title', this.feed.title);
                form_data.append('content', this.feed.content);
                form_data.append('type', this.category);
                form_data.append('vendorId', this.vendor._id);
                form_data.append('sendOn', new Date().toISOString());
                this.loaderEvent.fire(false);
                //form_data.append('sendToAll', true);
                form_data.append('facilities', this.feed.facilities.toString());
                this._feedService.sendFeed(form_data).then((result: any) => {
                    this.loaderEvent.fire(true);
                    this.popUpMessage = result.message;
                    backPopUpObj.showChildModal();

                });
                this.loaderEvent.fire(true);
            }
        } catch (e) {
            console.log(e);
        }
    }

    validateFeed(popupObj) {
        try {
            let validateFLag = true;
            if (!this.feed.title) {
                validateFLag = false;
                this.popUpMessage = CONSTANT_MESSAGES.ERROR_MESSAGE_SUBJECT;
                popupObj.showChildModal();
                return validateFLag;
            } else if (!this.feed.content) {
                validateFLag = false;
                this.popUpMessage = CONSTANT_MESSAGES.ERROR_MESSAGE_CONTENT;
                popupObj.showChildModal();
                return validateFLag;

            } else if (!this.feed.facilities.length) {
                validateFLag = false;
                this.popUpMessage = CONSTANT_MESSAGES.SELECT_ACTIVITY_FOR_ALERT;
                popupObj.showChildModal();
                return validateFLag;
            }
            return validateFLag;
        } catch (e) {
            console.log(e);
        }
    }

    goTOFeed() {
        this.feedService.goToFeed(this);
    }
}



// WEBPACK FOOTER //
// ./src/app/feed/compose-message/alert/alert.component.ts